package com.macrofocus.eflux.animation

data class Playback(val timeline: Timeline) {
}